// @charset "utf-8"
function _IEVersion () {
    var iev = 0
    var ieold = (/MSIE (\d+\.\d+);/.test(navigator.userAgent))
    var trident = !!navigator.userAgent.match(/Trident\/7.0/)
    var rv = navigator.userAgent.indexOf('rv:11.0')

    if (ieold) {
        iev = Number(RegExp.$1)
    }
    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
        iev = 10
    }
    if (trident && rv !== -1) {
        iev = 11
    }

    return iev
}

function _isEdge () {
    return /Edge\/12/.test(navigator.userAgent)
}

function exportCSV (tableStr, filename) {
    let ieVersion = _IEVersion()
    if (ieVersion && ieVersion < 10) { // ie < 10
        var win = window.top.open('about:blank', '_blank')
        win.document.write(tableStr)
        win.document.close()
        win.document.execCommand('SaveAs', true, filename)
        win.close()
    } else if (ieVersion || _isEdge()) { // ie >= 10 edge
        let csvData = new Blob(['\uFEFF' + tableStr], { type: 'text/csv' })
        navigator.msSaveBlob(csvData, filename + '.csv')
    } else { // chrome firefox ...
        let aDom = document.createElement('a')
        document.body.appendChild(aDom)
        let csvContent = 'data:attachment/csv;charset=utf-8,\ufeff' + encodeURIComponent(tableStr)
        aDom.href = csvContent
        aDom.download = filename + '.csv'
        aDom.click()
        document.body.removeChild(aDom)
    }
}

export default exportCSV



// WEBPACK FOOTER //
// ./src/lib/exportCsv.js